import { PipeTransform, Pipe } from '@angular/core';

@Pipe({
  name: 'formatPhone',
  standalone: false
})
export class FormatPhonePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return '';
    }
    // return original
    if (!value.startsWith('+41') && !value.startsWith('+49') && !value.startsWith('+43')) {
      return value;
    }
    // swiss format
    if (!value.startsWith('+49') && !value.startsWith('+43')) {
      const chArr: string[] = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,2})(\d{0,3})(\d{0,2})(\d{0,2})/);
      return `+${chArr[1]} ${chArr[2]} ${chArr[3]} ${chArr[4]} ${chArr[5]}`;
    }
    // germany format
    const chArr: string[] = value.replace(/\D/g, '').match(/(\d{0,2})(\d{0,4})(\d{0,7})/);
    return `+${chArr[1]} ${chArr[2]} ${chArr[3]}`;
  }
}
